module.exports = __webpack_public_path__ + "media/images/application/template/map-pin-d433ad397899cfed61bb7c6e06ec40a4.png";